import React, { Component } from "react";
import { getAuth } from 'firebase/auth';
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import NavBar from "../Components/NavBar";
import "./login.css";

const auth = getAuth();

class LoginClass extends Component {
    constructor(props) {
        super(props);
		this.login = this.login.bind(this);
		this.state = {
			email: "",
			password: "",
			redirect: "",
		};
    }

    handleChange(e) {
		this.setState({ [e.target.name]: e.target.value });
	}

	//logs in...changes error message depending on result
	login(e) {
		e.preventDefault();
		signInWithEmailAndPassword(auth, this.state.email, this.state.password)
			.then((userCredential) => {
				console.log("logged in");
				//if logged in go to makepost page
				this.props.navigate("/makepost");
				console.log(this.state.redirect);
			})
			.catch((error) => {
				console.log(error);
			});
	}

    render() {
        return (
            <>
                <NavBar/>
				<div className="loginform">
                    <h1 className="loginfont">Log In:</h1>
                    <label htmlFor="email">
                        <b>Email</b>
                    </label>{" "}
                    <br></br>
                    <input
                        value={this.state.email}
                        onChange={this.handleChange.bind(this)}
                        type="text"
                        name="email"
                        className="form-control"
                        id="exampleInputEmail1"
                        aria-describedby="emailHelp"
                        placeholder="Enter email"
                    />
                    <br></br>
                    <label htmlFor="psw">
                        <b>Password</b>
                    </label>
                    <input
                        value={this.state.password}
                        onChange={this.handleChange.bind(this)}
                        type="password"
                        name="password"
                        className="form-control"
                        id="exampleInputPassword1"
                        placeholder="Password"
                    />
                    <button type="submit" onClick={this.login} className="btn btn-primary">
                        Login
                    </button>
                </div>
             </>
        )
    }
}

// Wrapper to use hooks with class component
function Login(props) {
    const navigate = useNavigate();
    return <LoginClass {...props} navigate={navigate} />;
}

export default Login;
